import BigNumber from "bignumber.js";
import { formatPrice } from "./lib/format-price";
import { SummaryLine } from "./summary-line";
import { PaymentDetailsProps } from "./types";
import { PaymentDetailsHeader } from "./payment-details-header";

export const ECFPaymentDetails = ({
	title,
	updatedAt,
	investmentId,
	createdAt,
	price = "0",
	quantity = "0",
	currency = "USD",
	company,
	className,
}: PaymentDetailsProps) => {
	const priceBN = BigNumber(price);
	const quantityBN = BigNumber(quantity);
	const totalInvestment = priceBN.multipliedBy(quantityBN);
	const totalFee = totalInvestment.toNumber();

	return (
		<>
			<div className={`rounded-lg border p-4 pt-0 w-[600px] ${className}`}>
				<div className="flex flex-col gap-4">
					<PaymentDetailsHeader
						title={title}
						updatedAt={updatedAt}
						investmentId={investmentId}
						createdAt={createdAt}
					/>
					{company && <SummaryLine field="Company" value={company} isText />}
					<SummaryLine
						field="Price"
						value={
							<>
								<span className="font-bold">
									{currency.toUpperCase()} {formatPrice(priceBN.toNumber())}
								</span>{" "}
								/ Share
							</>
						}
					/>
					<SummaryLine
						field="Quantity"
						value={<span>{formatPrice(quantityBN.toNumber())} Shares</span>}
					/>
					<SummaryLine
						field="Total investment amount"
						value={`${currency.toUpperCase()} ${formatPrice(
							totalInvestment.toNumber(),
						)}`}
					/>
					<hr />
					<div className="flex justify-between">
						<div className="text-sm font-bold text-gray-600">Total</div>
						<div className="text-sm font-bold text-[#383838]">{`${currency.toUpperCase()} ${formatPrice(
							totalFee,
						)}`}</div>
					</div>
				</div>
			</div>
		</>
	);
};
